module.exports = __webpack_public_path__ + "static/media/DocF1.511a47cc.jpg";